module.exports = __webpack_public_path__ + "static/drive1-min-38264ab4f904dbf5995af6d890dfc5f8.png";